<template>
  <nav>
    <button
      id="menu-toggle"
      :class="{'active' : menuActive}"
      @click="toggleMenu"
      aria-expanded="false"
      aria-controls="main-menu"
      aria-label="Toggle Menu">
      <!-- Hide from screen readers -->
      <span aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
    <div id="menu-underlay" @click="toggleMenu" v-show="menuActive"></div>
    <transition name="slide">
      <div id="menu-container" v-show="menuActive">
        <h2 aria-hidden="true"><router-link :to="'/'" exact>Beyond School</router-link></h2>
        <ul
          id="main-menu"
          role="menu"
          aria-label="Main Menu"
        >
          <li role="none">
            <router-link :to="'/norway'">Culture <em>Norway</em></router-link>
          </li>
          <li role="none">
            <router-link :to="'/nepal'">Language <em>Nepal</em></router-link>
          </li>
          <li role="none">
            <router-link :to="'/kenya'">Inclusion <em>Kenya</em></router-link>
          </li>
          <li role="none">
            <router-link :to="'/pakistan'">Religion <em>Pakistan</em></router-link>
          </li>
          <li role="none">
            <router-link :to="'/credits'">Credits</router-link>
          </li>
        </ul>
        <div class="credit">
          <p>A project of the <a href="https://globalreportingprogram.org">Global Reporting Program</a>.</p>
          <a href="https://globalreportingprogram.org"><img width="150" height="90" :src="require(`@/assets/img/grp.svg`)" alt="Global Reporting Program" /></a>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: 'SiteNavigation',
  data () {
    return {
      menuActive: false
    }
  },
  props: {
    isPlaying: Boolean,
    activeEpisode: String
  },
  methods: {
    toggleMenu: function() {
      this.menuActive = !this.menuActive
    },
    playPause: function(episode) {
      if (this.isPlaying && this.activeEpisode === episode) {
        // If audio player is playing and the active episode is the same as the loaded filename
        this.$emit('pause', episode)
      }
      else {
        this.$emit('play', episode)
      }
    },
    playState: function(episode) {
      if (this.isPlaying && this.activeEpisode === episode) {
        return 'playing'
      }
      else if (this.activeEpisode === episode) {
        return 'paused'
      }
      else {
        return 'play'
      }
    }
  },
  watch: {
    // Close the menu when we change routes
    // (since we're in HTML5 history mode, router-link intercepts click events to prevent the page from reloading)
    $route() {
      if (this.menuActive) {
        this.menuActive = false
      }
    }
  }
}
</script>

<style lang="scss">

button#menu-toggle {
  position: fixed;
  z-index: 5;
  top: 0.85rem;
  right: 1.25rem;
  height: 1.8rem;
  width: 1.4rem;
  display: block;
  transition: transform 0.5s cubic-bezier(.15, .85, .50, 1), background-color 0.3s;
  border: none;
  background-color: $black;
  padding: 1rem;
  border-radius: 2px;
  @include focus-shadow;
  span span {
    background-color: $white;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 2px;
    width: 1.4rem;
    transition: transform 0.6s cubic-bezier(.165,.84,.44,1), opacity 0.3s cubic-bezier(.165,.84,.44,1);
    &:first-child {
      transform: translateY(-6px);
      }
      &:nth-child(2) {
        transform-origin: 100% 50%;
        transform: scaleX(0.8);
      }
      &:last-child {
        transform: translateY(6px);
      }
  }
  &:hover {
    span span:nth-child(2) {
      transform: scaleX(1);
    }
  }
  &.active {
    transform: rotate(-180deg);
    background-color: transparent;
    span span {
      &:first-child {
        transform: rotate(45deg);
      }
      &:nth-child(2) {
        opacity: 0;
      }
      &:last-child {
        transform: rotate(-45deg);
      }
    }
  }
}

#menu-container {
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 85vw;
  z-index: 4;
  max-width: 17em;
  background: $black;
  color: $white;
  h2 {
    font-size: 1rem;
    padding: 0 3.6rem 0 1rem;
    height: 3.6rem;
    line-height: 3.6rem;
    margin: 0;
    a {
      color: $white !important;
      text-decoration: none;
    }
  }
  p a {
    color: $white !important;
  }
  h2, a.router-link-active {
    transition-delay: 0.4s;
  }
  #main-menu {
    list-style-type: none;
    margin: 0;
    padding: 0.5rem;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid lighten($black, 10%);
    }

    a, button.play {
      color: $white;
      display: block;
      width: 100%;
      padding: 0.7rem 0.5rem;
      text-decoration: none;
      border-left-width: 2px;
      border-left-style: solid;
      border-left-color: transparent;
    }

    a em {
      display: block;
      font-size: 0.8em;
      @include sm {
        display: inline-block;
        font-size: 0.9em;
        margin-left: 0.5rem;
      }
    }

    button.play {
      text-transform: uppercase;
      font-size: 0.9em;
      font-family: monospace;
    }
  }
  div.credit {
    font-size: 0.8em;
    display: flex;
    justify-content: space-between;
    color: darken($white, 20%);
    padding: 0 1rem 2rem;
    align-items: center;
    p {
      margin-bottom: 0;
      line-height: 1.6;
    }
    a {
      color: darken($white, 20%);
      transition: color 0.2s;
      &:hover, &:focus {
        color: $white;
      }
    }
    img {
      max-width: 75px;
    }
  }
}

#menu-underlay {
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 2;
}

</style>